import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import encodeListFilterValues, { readListFilterValues } from "~/helpers/listFilterValues";
import { sameGuid } from "~/helpers/wsId";
import { LOCATIONS_PATH } from "~restock/data-management/locations/helpers/restockStoreReceiverIdentity";

const STORE_LIST_TARGET_KIND = "restockStoreList";

const buildStoreListTarget = (listId: string, locationIds: readonly string[]): ContinuationTarget => ({
	listFilters: { locationIds: encodeListFilterValues(locationIds) },
	targetId: listId,
	targetKind: STORE_LIST_TARGET_KIND
});

const readStoreListScope = (listFilters: Record<string, string> | undefined): null | string[] =>
	readListFilterValues(listFilters?.locationIds);

const isInScope = (scopedIds: readonly string[], locationId: string): boolean =>
	scopedIds.some((id) => sameGuid(id, locationId));

const missingStoreIds = (scopedIds: readonly string[], stores: readonly { locationId: string }[]): string[] =>
	scopedIds.filter((id) => !stores.some((store) => sameGuid(store.locationId, id)));

const storeListReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => LOCATIONS_PATH,
	matchesRoute: () => null
};

const storeListScope = {
	adapter: storeListReceiverIdentityAdapter,
	buildStoreListTarget,
	isInScope,
	missingStoreIds,
	readStoreListScope,
	STORE_LIST_TARGET_KIND
} as const;

export default storeListScope;
